// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sarge-main-ui .sarge-welcome-bubble {
  display: none;
}
.sarge-main-ui .sarge-icon-wrapper {
  width: 30px;
  height: 30px;
}
.sarge-main-ui .sarge-icon.microphone {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/guideai-app-handler/styles.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;AAAJ;AAFA;EAMI,WAAA;EACA,YAAA;AADJ;AANA;EAWI,WAAA;EACA,YAAA;AAFJ","sourcesContent":[".sarge-main-ui {\n  .sarge-welcome-bubble {\n    display: none;\n  }\n\n  .sarge-icon-wrapper {\n    width: 30px;\n    height: 30px;\n  }\n\n  .sarge-icon.microphone {\n    width: 20px;\n    height: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
